import { apiRoutes } from "../../config/apiRoutes.config.js";

export const cmtsDashboardReportApiRoutes = {
  dashboard: {
    summary: apiRoutes.dashboards.summary,
    executive: apiRoutes.dashboards.executive,
    management: apiRoutes.dashboards.management,
    personal: apiRoutes.dashboards.personal,
    complaintLifecycle: apiRoutes.dashboards.complaintLifecycle,
    rcaCapa: apiRoutes.dashboards.rcaCapa,
    sla: apiRoutes.dashboards.slaDashboard,
    evidence: apiRoutes.dashboards.evidence,
    metricDetail: apiRoutes.dashboards.metricDetail,
    chartData: apiRoutes.dashboards.chartData,
    drilldown: apiRoutes.dashboards.drilldown,
  },
  reports: {
    catalog: apiRoutes.reports.catalog,
    schema: apiRoutes.reports.schema,
    preview: apiRoutes.reports.previewByCode,
    legacyPreview: apiRoutes.reports.preview,
    export: apiRoutes.reports.export,
    exportStatus: apiRoutes.reports.exportStatus,
    download: apiRoutes.reports.download,
  },
  audit: {
    logs: apiRoutes.auditLogs.list,
    detail: apiRoutes.auditLogs.detail,
    export: apiRoutes.auditLogs.export,
  },
  security: {
    logs: apiRoutes.securityLogs.list,
    detail: apiRoutes.securityLogs.detail,
    export: apiRoutes.securityLogs.export,
  },
} as const;
